import { GET } from '../request'

export const getLlamadasAlumno = alumnoId =>
  GET('/api/agora/marketing/llamada/list/alumno', { alumno: alumnoId })

export const getLlamadasLead = feedbackId =>
  GET('/api/agora/marketing/llamada/list/feedback', { feedback: feedbackId })
